import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Cabins from "@/pages/Cabins";
import Marina from "@/pages/Marina";
import Boating from "@/pages/Boating";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Accessibility from "@/pages/Accessibility";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";
import RouteMeta from "@/components/RouteMeta";
import { SITE } from "@/data/content";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <a href="#main-content" className="skip-link" data-testid="skip-to-content-link">
          Skip to main content
        </a>
        <ScrollToTop />
        <RouteMeta />
        <Navbar />
        <div id="main-content" tabIndex={-1} className="focus:outline-none">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cabins" element={<Cabins />} />
            <Route path="/marina" element={<Marina />} />
            <Route path="/boating" element={<Boating />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            {SITE.privacyPolicyApproved && <Route path="/privacy" element={<Privacy />} />}
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
